export enum UserRoles {
    Admin = 'CaseStudies.Admin',
    Viewer = 'CaseStudies.Viewer',
    ContentManager = 'CaseStudies.ContentManager',
    SuperAdmin = 'CaseStudies.SuperAdmin'
}
